// store/auth.js

// import * as dashboard from './user';
import axios from "axios";
import { apis } from '../../apis/admin';
// import router from "../../../router/index";

const state = {
    // Additional state if needed
    getDiscussion: '',
    discussionById: '',
}

const mutations = {
    SET_DISCUSSION_DATA(state, data) {
        state.getDiscussion = data
    },
    SET_DISCUSSION_BY_ID(state, data) {
        state.discussionById = data
    },
}

const actions = {
    // Additional actions if needed
      getDiscussion({ commit }, id) {
            // return
            // return new Promise((resolve, reject) => {
                axios
                    .get(axios.defaults.baseURL + apis.GET_DISCUSSION_ADMIN_ID + id, {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token"),
                            "ngrok-skip-browser-warning": "69420",
                        },
                    })
                    .then((res) => {
                        console.log('getDiscussion---res !!', res)
                        if(Array.isArray(res.data.data)){
                            commit('SET_DISCUSSION_DATA', res.data.data)
                        }
                        else{
                           commit('SET_DISCUSSION_DATA', res.data.message)
                        }
                    })
                    .catch((err) => {
                        console.log('getDiscussion err', err)
                    })
            // })
    },

    getDiscussionById({ commit }, id) {
        // return
        // return new Promise((resolve, reject) => {
            axios
                .get(axios.defaults.baseURL + apis.GET_DISCUSSION_BY_ID + id, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log('getDiscussionById---res !!', res)
                    if(res.data.data){
                        commit('SET_DISCUSSION_BY_ID', res.data.data)
                    }
                    else{
                       commit('SET_DISCUSSION_BY_ID', res.data.message)
                    }
                })
                .catch((err) => {
                    console.log('getDiscussionById err', err)
                })
        // })
    },

    addDiscussion({dispatch}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("topic", payload.topic);
        formData.append("message", payload.message);
        formData.append("file", payload.file);
        formData.append("userId", payload.userId);
        formData.append("adminId", payload.adminId);
        
        return new Promise((resolve, reject) => {
            axios
                .post(axios.defaults.baseURL + apis.ADD_DISCUSSION, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log("addDiscussion res", res);
                    resolve(res);
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    // router.push("/all-enquiries")
                    dispatch('getDiscussion', payload.adminId)
                })
                .catch((err) => {
                    console.log("addDiscussion err", err);
                    reject(err);
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                });
        });
    },

    editDiscussion({dispatch}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("topic", payload.topic);
        formData.append("message", payload.message);
        formData.append("file", payload.file);
        
        return new Promise((resolve, reject) => {
            axios
                .patch(axios.defaults.baseURL + apis.EDIT_DISCUSSION_BY_ID + payload.id, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log("editDiscussion res", res);
                    resolve(res);
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    // router.push("/my-enquiries")
                    dispatch('getDiscussion', payload.adminId)
                })
                .catch((err) => {
                    console.log("editDiscussion err", err);
                    reject(err);
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                });
        });
    },


    deleteDiscussionById({dispatch }, payload) {
        // return
        return new Promise((resolve, reject) => {
            axios
                .delete(axios.defaults.baseURL + apis.DELETE_DISCUSSION_BY_ID + payload.id, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log('deleteDiscussionById---res !!', res)
                    resolve(res)
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    dispatch('getDiscussion', payload.adminId)
                })
                .catch((err) => {
                    reject(err)
                    console.log('deleteDiscussionById err', err)
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                })
        })
    },


    // Comments Apis
    addDiscussionComment({dispatch}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("comment", payload.comment);
        formData.append("userId", payload.userId);
        
        return new Promise((resolve, reject) => {
            axios
                .post(axios.defaults.baseURL + apis.DISCUSSION_ADD_COMMENTS_BY_ID + payload.id, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log("addComment res", res);
                    resolve(res);
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    // router.push("/all-enquiries")
                    dispatch('getDiscussionById', payload.id)
                })
                .catch((err) => {
                    console.log("addComment err", err);
                    reject(err);
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                });
        });
    },

    addDiscussionCommentReply({dispatch}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("reply", payload.reply);
        formData.append("userId", payload.userId);
        
        return new Promise((resolve, reject) => {
            axios
                .post(axios.defaults.baseURL + apis.DISCUSSION_ADD_COMMENTS_REPLY_BY_ID + payload.discussionId + "/" + payload.commentId, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log("addCommentReply res", res);
                    resolve(res);
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    // router.push("/all-enquiries")
                    dispatch('getDiscussionById', payload.discussionId)
                })
                .catch((err) => {
                    console.log("addCommentReply err", err);
                    reject(err);
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                });
        });
    },

    deleteDiscussionCommentById({dispatch }, payload) {
        // return
        return new Promise((resolve, reject) => {
            axios
                .delete(axios.defaults.baseURL + apis.DISCUSSION_DELETE_COMMENTS_BY_ID + payload.noticeId + "/" + payload.id, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log('deleteCommentById---res !!', res)
                    resolve(res)
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    dispatch('getDiscussionById', payload.noticeId)
                })
                .catch((err) => {
                    reject(err)
                    console.log('deleteCommentById err', err)
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                })
        })
    },

    deleteReplyDiscussionCommentById({dispatch }, payload) {
        // return
        return new Promise((resolve, reject) => {
            axios
                .delete(axios.defaults.baseURL + apis.DISCUSSION_DELETE_COMMENTS_REPLY_BY_ID + payload.noticeId + "/" + payload.id +  "/" + payload.getCmentId, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log('deleteReplyCommentById---res !!', res)
                    resolve(res)
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    dispatch('getDiscussionById', payload.noticeId)
                })
                .catch((err) => {
                    reject(err)
                    console.log('deleteReplyCommentById err', err)
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                })
        })
    },

    commentDiscussionLike({dispatch}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("userId", payload.userId);
        
        return new Promise((resolve, reject) => {
            axios
                .patch(axios.defaults.baseURL + apis.DISCUSSION_COMMENTS_LIKES_BY_ID + payload.noticeId + "/" + payload.id, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log("commentLike res", res);
                    resolve(res);
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    // router.push("/my-enquiries")
                    dispatch('getDiscussionById', payload.noticeId)
                })
                .catch((err) => {
                    console.log("commentLike err", err);
                    reject(err);
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                });
        });
    },

    commentDiscussionLikeOnReply({dispatch}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("userId", payload.userId);
        
        return new Promise((resolve, reject) => {
            axios
                .patch(axios.defaults.baseURL + apis.DISCUSSION_COMMENTS_REPLY_LIKES_BY_ID + payload.noticeId + "/"+ payload.commentId + "/" + payload.replyCommentId, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log("commentLikeOnReply res", res);
                    resolve(res);
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    // router.push("/my-enquiries")
                    dispatch('getDiscussionById', payload.noticeId)
                })
                .catch((err) => {
                    console.log("commentLikeOnReply err", err);
                    reject(err);
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                });
        });
    },

}

const getters = {
    // Additional getters if needed
}

export default {
    state,
    mutations,
    actions,
    getters,
  };